import {
  BUILTIN_VARIABLES,
  METADATA_PREFIX as SHARED_METADATA_PREFIX,
} from '@/Domain/components/Action/Lexical/availableVariables';
import { HttpActionForm } from '@/Domain/hooks/Action/ApiAction/useHttpRequestActionFormV2.hook';

// Derived from the shared `BUILTIN_VARIABLES` so badge-validation and Test Response classification stay in sync; extend that source, not this list.
export const BUILTIN_VARIABLE_NAMES = BUILTIN_VARIABLES.map((v) => v.name);

export const METADATA_PREFIX = SHARED_METADATA_PREFIX;

const PARAMETER_PATTERN = /\{\{([^}]+)\}\}/g;

type DetectedSystemVariables = {
  builtin: string[];
  metadata: string[];
};

export const detectSystemVariables = (formValues: HttpActionForm): DetectedSystemVariables => {
  const found = new Set<string>();

  const scan = (text: string) => {
    for (const match of text.matchAll(PARAMETER_PATTERN)) {
      const name = match[1].trim().replace(/\s+/g, '_');
      found.add(name);
    }
  };

  if (formValues.url) scan(formValues.url);

  for (const header of formValues.headers ?? []) {
    if (header.name) scan(header.name);
    if ('value' in header && header.value) scan(header.value);
  }

  for (const item of formValues.body_items ?? []) {
    if (item.name) scan(item.name);
    if ('content' in item && item.content) scan(item.content);
  }

  for (const item of formValues.query_items ?? []) {
    if (item.name) scan(item.name);
    if ('value' in item && item.value) scan(item.value);
  }

  if (formValues.body_items_json_enable && formValues.body_items_json) {
    scan(formValues.body_items_json);
  }

  const parameterNames = new Set(
    (formValues.parameters ?? []).map((p) => p.name.replace(/\s+/g, '_')),
  );

  const builtin: string[] = [];
  const metadata: string[] = [];

  for (const name of found) {
    if (parameterNames.has(name)) continue;

    if ((BUILTIN_VARIABLE_NAMES as readonly string[]).includes(name)) {
      builtin.push(name);
    } else if (name.startsWith(METADATA_PREFIX)) {
      metadata.push(name);
    }
  }

  return { builtin, metadata };
};
